import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [email, setEmail] = useState('');
  const [showScrollNav, setShowScrollNav] = useState(false);

  // Handle scroll for navbar
  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        setShowScrollNav(true);
      } else {
        setShowScrollNav(false);
      }
    });
  }

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle subscription
    alert('Thank you for subscribing!');
    setEmail('');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FFF8F0] via-[#FFE8E0] to-[#0A1628]">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${showScrollNav ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/019b65516b6f4faeb551f203100f56f5/009a7900ab7c5cabd69e80a4b3b0aec5.png" 
              alt="Logo" 
              className="h-12 w-auto"
            />
          </div>
          <div className="flex items-center gap-8">
            <a href="#about" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">About</a>
            <a href="#ebooks" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">eBooks</a>
            <a href="#contents" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">Contents</a>
            <a href="#author" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer whitespace-nowrap">Author</a>
            <a href="https://lnk.bio/bose111" target="_blank" rel="noopener noreferrer" className="bg-black text-white px-6 py-2.5 rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap">Purchase</a>
          </div>
        </div>
      </nav>

      {/* Hero Section - Cover */}
      <section className="min-h-screen flex items-center pt-20">
        <div className="max-w-7xl mx-auto px-6 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow-sm">
                <i className="ri-book-2-line text-[#FF6B4A]"></i>
                <span className="text-sm font-medium">ADVANCED EDITION</span>
              </div>
              <h1 className="text-7xl font-bold leading-tight text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
                Master Networking & Cybersecurity
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                From beginner to job-ready with Cisco Packet Tracer. Comprehensive hands-on labs covering VLAN, Inter-VLAN Routing, DHCP, Network Security, Attack Simulations, and Capstone Projects.
              </p>
              <div className="flex items-center gap-4 pt-4">
                <a href="https://lnk.bio/bose111" target="_blank" rel="noopener noreferrer" className="bg-black text-white px-8 py-4 rounded-full hover:bg-gray-800 transition-all cursor-pointer whitespace-nowrap text-lg font-medium">
                  Purchase Now
                </a>
                <a href="#contents" className="text-gray-900 hover:text-gray-700 transition-colors cursor-pointer whitespace-nowrap text-lg underline">
                  View Contents
                </a>
              </div>
            </div>
            <div className="relative">
              <div className="relative transform hover:scale-105 transition-transform duration-300">
                <div className="absolute inset-0 bg-gradient-to-br from-[#FF6B4A]/20 to-[#0A1628]/20 rounded-2xl blur-3xl"></div>
                <div className="relative w-full h-full" style={{ width: '600px', height: '800px' }}>
                  <img 
                    src="https://static.readdy.ai/image/019b65516b6f4faeb551f203100f56f5/fec8be2e787ba4fc631e36307dff5d35.png" 
                    alt="Practical Networking & Cybersecurity Labs - Advanced Edition" 
                    className="relative rounded-2xl shadow-2xl w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* eBooks Collection Section */}
      <section id="ebooks" className="py-32 bg-[#E8F4E8]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="w-2 h-2 bg-[#FF6B4A] rounded-full mx-auto mb-4"></div>
            <p className="text-sm uppercase tracking-wider text-gray-600 mb-4">OUR COLLECTION</p>
            <h2 className="text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Professional eBook Series
            </h2>
            <p className="text-xl text-gray-600">Comprehensive guides for IT professionals and learners</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            {/* Featured eBook */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer">
              <div className="relative mb-6 w-full h-full" style={{ width: '100%', height: '400px' }}>
                <img 
                  src="https://static.readdy.ai/image/019b65516b6f4faeb551f203100f56f5/fec8be2e787ba4fc631e36307dff5d35.png" 
                  alt="Practical Networking & Cybersecurity Labs" 
                  className="rounded-lg shadow-md w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-[#FF6B4A] text-white px-3 py-1 rounded-full text-sm font-bold">
                  BESTSELLER
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Practical Networking & Cybersecurity Labs
              </h3>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Advanced Edition - From Beginner to Job-Ready with Cisco Packet Tracer
              </p>
              <div className="flex items-center justify-between mb-4">
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#FF6B4A]"></i>
                  ))}
                </div>
                <span className="text-sm text-gray-500">4.9 (2,847 reviews)</span>
              </div>
              <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                <div>
                  <span className="text-3xl font-bold text-gray-900">$29.99</span>
                  <span className="text-sm text-gray-500 line-through ml-2">$49.99</span>
                </div>
                <a href="https://lnk.bio/bose111" target="_blank" rel="noopener noreferrer" className="bg-black text-white px-6 py-2.5 rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap">
                  Buy Now
                </a>
              </div>
            </div>

            {/* Second eBook - The Virus War */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer">
              <div className="relative mb-6 w-full h-full" style={{ width: '100%', height: '400px' }}>
                <img 
                  src="https://static.readdy.ai/image/019b65516b6f4faeb551f203100f56f5/e72db3ecd146d64beffe26a2a9e525da.png" 
                  alt="The Virus War - Defending Against Digital Attacks" 
                  className="rounded-lg shadow-md w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-[#4CAF50] text-white px-3 py-1 rounded-full text-sm font-bold">
                  NEW
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                The Virus War: Defending Against Digital Attacks
              </h3>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Essential guide to understanding and combating modern cyber threats and malware
              </p>
              <div className="flex items-center justify-between mb-4">
                <div className="flex gap-1">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#FF6B4A]"></i>
                  ))}
                </div>
                <span className="text-sm text-gray-500">5.0 (324 reviews)</span>
              </div>
              <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                <div>
                  <span className="text-3xl font-bold text-gray-900">$7.66</span>
                </div>
                <a href="https://lnk.bio/bose111" target="_blank" rel="noopener noreferrer" className="bg-black text-white px-6 py-2.5 rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap">
                  Buy Now
                </a>
              </div>
            </div>

            {/* Placeholder for more ebooks */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer border-2 border-dashed border-gray-300">
              <div className="flex flex-col items-center justify-center h-full text-center py-12">
                <div className="w-20 h-20 flex items-center justify-center bg-gray-100 rounded-full mb-6">
                  <i className="ri-book-line text-4xl text-gray-400"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  More eBooks Coming Soon
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  Subscribe to our newsletter to be notified when new titles are released.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About the Ebook */}
      <section id="about" className="py-32 bg-[#FFF8F0]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="w-2 h-2 bg-[#FF6B4A] rounded-full mx-auto mb-4"></div>
            <p className="text-sm uppercase tracking-wider text-gray-600 mb-4">ABOUT THIS BOOK</p>
            <h2 className="text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Your Complete Guide to<br />Networking Excellence
            </h2>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2 space-y-6">
              <p className="text-xl text-gray-700 leading-relaxed first-letter:text-7xl first-letter:font-bold first-letter:text-[#FF6B4A] first-letter:float-left first-letter:mr-3 first-letter:leading-none">
                This comprehensive guide takes you from networking fundamentals to advanced cybersecurity implementations using Cisco Packet Tracer. Whether you're preparing for certifications or building practical skills for your career, this book provides hands-on experience with real-world scenarios.
              </p>
              <p className="text-xl text-gray-700 leading-relaxed">
                Master essential networking concepts including VLAN configuration, Inter-VLAN routing, DHCP implementation, and network security protocols. Each chapter includes detailed lab exercises that you can practice in Cisco Packet Tracer, ensuring you gain practical experience alongside theoretical knowledge.
              </p>
              <p className="text-xl text-gray-700 leading-relaxed">
                The advanced edition includes attack simulation labs and comprehensive capstone projects that prepare you for real-world networking challenges. By the end of this book, you'll have the confidence and skills to design, implement, and secure enterprise networks.
              </p>
            </div>
            
            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B4A] rounded-full flex-shrink-0">
                  <i className="ri-terminal-box-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Hands-On Labs</h3>
                  <p className="text-gray-600">Practical exercises using Cisco Packet Tracer for real-world experience.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B4A] rounded-full flex-shrink-0">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Security Focus</h3>
                  <p className="text-gray-600">Learn to implement and test network security measures effectively.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B4A] rounded-full flex-shrink-0">
                  <i className="ri-graduation-cap-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Career Ready</h3>
                  <p className="text-gray-600">Build skills that employers are actively seeking in IT professionals.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B4A] rounded-full flex-shrink-0">
                  <i className="ri-file-list-3-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Comprehensive Coverage</h3>
                  <p className="text-gray-600">From basic concepts to advanced implementations and troubleshooting.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Table of Contents */}
      <section id="contents" className="py-32 bg-gradient-to-br from-[#0A1628] to-[#1A2F4F]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20">
            <h2 className="text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              What You'll Learn
            </h2>
            <p className="text-xl text-white/80">Comprehensive curriculum covering essential networking and security topics</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: 'ri-router-line', title: 'VLAN Configuration', desc: 'Master virtual LAN setup and management for network segmentation' },
              { icon: 'ri-route-line', title: 'Inter-VLAN Routing', desc: 'Implement routing between VLANs using Layer 3 switches and routers' },
              { icon: 'ri-server-line', title: 'DHCP & Network Services', desc: 'Configure dynamic IP addressing and essential network services' },
              { icon: 'ri-shield-keyhole-line', title: 'Network Security', desc: 'Implement security protocols, ACLs, and firewall configurations' },
              { icon: 'ri-bug-line', title: 'Attack Simulations', desc: 'Understand common network attacks and defense mechanisms' },
              { icon: 'ri-tools-line', title: 'Troubleshooting', desc: 'Develop systematic approaches to diagnose and resolve network issues' },
              { icon: 'ri-git-branch-line', title: 'Network Design', desc: 'Plan and design scalable enterprise network architectures' },
              { icon: 'ri-lock-password-line', title: 'Access Control', desc: 'Configure port security, 802.1X, and authentication protocols' },
              { icon: 'ri-folder-shield-line', title: 'Capstone Projects', desc: 'Apply all learned skills in comprehensive real-world scenarios' }
            ].map((topic, index) => (
              <div 
                key={index}
                className="relative bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all duration-300 hover:-translate-y-2 cursor-pointer group border border-white/20"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-[#FF6B4A] rounded-xl mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${topic.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-[#FF6B4A] transition-colors">
                  {topic.title}
                </h3>
                <p className="text-white/70 leading-relaxed">
                  {topic.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sample Chapter */}
      <section id="sample" className="py-32 bg-[#2D2D2D] relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
            <pattern id="world-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <circle cx="50" cy="50" r="1" fill="white"/>
            </pattern>
            <rect width="100%" height="100%" fill="url(#world-pattern)"/>
          </svg>
        </div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-white px-4 py-2 rounded-full mb-8">
              <i className="ri-download-line text-[#FF6B4A]"></i>
              <span className="text-sm font-medium">FREE PREVIEW</span>
            </div>
            <h2 className="text-7xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Read a Sample<br />Chapter Now
            </h2>
          </div>
          
          <div className="bg-white rounded-3xl p-16 max-w-5xl mx-auto shadow-2xl">
            <div className="mb-8">
              <span className="text-[#FF6B4A] text-sm font-bold uppercase tracking-wider">Chapter 03</span>
              <h3 className="text-4xl font-bold text-gray-900 mt-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                Content Strategy That Converts
              </h3>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-gray-700 leading-relaxed">
              <div className="space-y-4">
                <p>
                  Content is the foundation of any successful digital strategy. But creating content that truly resonates with your audience requires more than just putting words on a page. It demands a deep understanding of your audience's needs, desires, and pain points.
                </p>
                <p>
                  In this chapter, we'll explore the frameworks and methodologies that top content creators use to consistently produce engaging, valuable content that drives real business results.
                </p>
              </div>
              
              <div className="space-y-4">
                <p>
                  You'll learn how to identify content opportunities, develop a sustainable content calendar, and create pieces that not only attract attention but also build trust and authority in your niche.
                </p>
                <p>
                  We'll dive into the psychology of content consumption, understanding what makes people click, read, and share. You'll discover the secret formulas behind viral content and how to adapt them to your unique brand voice.
                </p>
              </div>
              
              <div className="space-y-4">
                <p>
                  From blog posts and videos to podcasts and social media updates, we'll cover the full spectrum of content formats and help you choose the right mix for your goals and resources.
                </p>
                <p>
                  By the end of this chapter, you'll have a clear roadmap for creating content that not only engages your audience but also drives measurable business outcomes.
                </p>
              </div>
            </div>
            
            <div className="relative mt-8 h-32 bg-gradient-to-t from-white to-transparent"></div>
            
            <div className="text-center mt-8">
              <button className="bg-[#FF6B4A] text-white px-10 py-4 rounded-full hover:bg-[#FF5A39] transition-colors cursor-pointer whitespace-nowrap text-lg font-medium">
                Read Full Chapter
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Author Bio */}
      <section id="author" className="py-32 bg-[#FFF8F0]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative">
              <div className="absolute inset-0 bg-[#FF6B4A] rounded-2xl transform rotate-3"></div>
              <div className="relative w-full h-full" style={{ width: '500px', height: '500px' }}>
                <img 
                  src="https://static.readdy.ai/image/019b65516b6f4faeb551f203100f56f5/47ad227f9526777fbbdc3e9160d9c253.png" 
                  alt="Abosede Ogunlade" 
                  className="rounded-2xl border-4 border-[#FF6B4A] relative z-10 w-full h-full object-cover object-top"
                />
              </div>
            </div>
            
            <div className="space-y-6">
              <p className="text-sm uppercase tracking-wider text-gray-600">MEET THE AUTHOR</p>
              <h2 className="text-5xl font-bold text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
                Abosede Ogunlade
              </h2>
              <p className="text-xl text-[#FF6B4A] font-medium">
                Cybersecurity Analyst | Information Security | Network Security Engineer
              </p>
              
              <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
                <p>
                  Abosede Ogunlade is a dedicated cybersecurity specialist with 2 years of hands-on experience in safeguarding organizations from digital threats and ensuring the integrity of their information systems. Her expertise spans threat intelligence, security architecture, vulnerability management, and incident response.
                </p>
                <p>
                  With certifications in Cybersecurity Analysis and Cybersecurity Threat Management, Abosede specializes in utilizing cutting-edge tools and techniques to identify and analyze potential security threats, allowing for proactive mitigation measures. She has successfully developed robust security architectures and frameworks to protect critical assets from cyberattacks.
                </p>
                <p>
                  As a passionate educator, Abosede has created this comprehensive guide to help aspiring cybersecurity professionals build practical skills using Cisco Packet Tracer. Her hands-on approach bridges the gap between theoretical knowledge and real-world implementation, preparing readers for successful careers in network security and cybersecurity.
                </p>
              </div>
              
              <div className="flex items-center gap-6 pt-6">
                <a href="#" className="w-12 h-12 flex items-center justify-center border-2 border-gray-800 rounded-full hover:bg-gray-800 hover:text-white transition-all cursor-pointer">
                  <i className="ri-twitter-x-line text-xl"></i>
                </a>
                <a href="https://www.linkedin.com/in/abosede-ogunlade/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center border-2 border-gray-800 rounded-full hover:bg-gray-800 hover:text-white transition-all cursor-pointer">
                  <i className="ri-linkedin-line text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 flex items-center justify-center border-2 border-gray-800 rounded-full hover:bg-gray-800 hover:text-white transition-all cursor-pointer">
                  <i className="ri-global-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-32 bg-gradient-to-br from-[#E8E0F4] to-[#F0E8F4]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20">
            <div className="w-8 h-8 flex items-center justify-center mx-auto mb-4">
              <i className="ri-star-fill text-[#FF6B4A] text-2xl"></i>
            </div>
            <p className="text-sm uppercase tracking-wider text-gray-600 mb-4">READER REVIEWS</p>
            <h2 className="text-6xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              What Students Are Saying
            </h2>
            <p className="text-xl text-gray-600">Join thousands of successful networking professionals</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                stars: 5,
                title: 'Perfect for CCNA Preparation',
                text: 'This book helped me pass my CCNA exam on the first try! The hands-on labs in Packet Tracer made all the difference. The explanations are clear and the progression is logical.',
                name: 'Marcus Johnson',
                role: 'Network Engineer',
                avatar: 'https://public.readdy.ai/ai/img_res/fb20bb7442661396d9c76ea75755fd84.jpg'
              },
              {
                stars: 5,
                title: 'From Zero to Network Admin',
                text: 'I had no networking experience before this book. Now I\'m working as a junior network administrator. The practical labs gave me the confidence to apply for jobs.',
                name: 'Priya Sharma',
                role: 'Network Administrator',
                avatar: 'https://readdy.ai/api/search-image?query=professional%20indian%20female%20network%20administrator%20headshot%20portrait%20confident%20smile%20against%20neutral%20background%20modern%20tech%20style&width=100&height=100&seq=avatar008&orientation=squarish'
              },
              {
                stars: 5,
                title: 'Best Networking Resource',
                text: 'I\'ve read many networking books, but this one stands out. The security labs are particularly valuable. Great investment for anyone serious about networking.',
                name: 'Carlos Rodriguez',
                role: 'Security Analyst',
                avatar: 'https://readdy.ai/api/search-image?query=professional%20hispanic%20male%20cybersecurity%20analyst%20headshot%20portrait%20professional%20expression%20against%20neutral%20background%20modern%20tech%20style&width=100&height=100&seq=avatar009&orientation=squarish'
              },
              {
                stars: 5,
                title: 'Excellent Hands-On Approach',
                text: 'The step-by-step labs are incredibly detailed. I learned more from this book than from my college networking course. Highly recommend for self-learners!',
                name: 'Sarah Kim',
                role: 'IT Student',
                avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20IT%20student%20headshot%20portrait%20friendly%20smile%20against%20neutral%20background%20modern%20casual%20style&width=100&height=100&seq=avatar010&orientation=squarish'
              },
              {
                stars: 5,
                title: 'Career Game Changer',
                text: 'This book helped me transition from help desk to network engineering. The capstone projects are realistic and prepared me for actual job scenarios.',
                name: 'Ahmed Hassan',
                role: 'Network Engineer',
                avatar: 'https://readdy.ai/api/search-image?query=professional%20middle%20eastern%20male%20network%20engineer%20headshot%20portrait%20confident%20professional%20against%20neutral%20background%20modern%20business%20style&width=100&height=100&seq=avatar011&orientation=squarish'
              },
              {
                stars: 5,
                title: 'Worth Every Penny',
                text: 'The attack simulation labs alone are worth the price. Understanding both offensive and defensive techniques has made me a better network security professional.',
                name: 'Elena Popov',
                role: 'Security Specialist',
                avatar: 'https://readdy.ai/api/search-image?query=professional%20eastern%20european%20female%20security%20specialist%20headshot%20portrait%20confident%20expression%20against%20neutral%20background%20modern%20professional%20style&width=100&height=100&seq=avatar012&orientation=squarish'
              }
            ].map((review, index) => (
              <div key={index} className="bg-white rounded-2xl p-10 shadow-lg hover:shadow-xl transition-shadow">
                <div className="flex gap-1 mb-4">
                  {[...Array(review.stars)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-[#FF6B4A] text-xl"></i>
                  ))}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {review.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6">
                  {review.text}
                </p>
                <div className="flex items-center gap-3 pt-6 border-t border-gray-200">
                  <div className="w-12 h-12 flex items-center justify-center">
                    <img src={review.avatar} alt={review.name} className="rounded-full w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">{review.name}</p>
                    <p className="text-sm text-gray-600">{review.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Purchase Section */}
      <section id="purchase" className="py-32 bg-gradient-to-br from-[#0A1628] to-[#1A2F4F] relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1"/>
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)"/>
          </svg>
        </div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-7xl font-bold text-white mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
                Start Your Networking Career Today
              </h2>
              <a href="https://lnk.bio/bose111" target="_blank" rel="noopener noreferrer" className="group bg-white text-black px-8 py-5 rounded-full hover:scale-105 transition-all cursor-pointer whitespace-nowrap text-xl font-medium inline-flex items-center gap-4">
                <span>Buy Now</span>
                <div className="w-14 h-14 flex items-center justify-center bg-black rounded-full group-hover:bg-gray-800 transition-colors">
                  <i className="ri-arrow-right-line text-white text-2xl"></i>
                </div>
              </a>
            </div>
            
            <div className="text-right">
              <p className="text-white/80 text-xl mb-4">Limited time offer</p>
              <div className="text-white">
                <span className="text-7xl font-bold">$29</span>
                <span className="text-3xl">.99</span>
              </div>
              <p className="text-white/60 text-lg mt-4">Regular price: $49.99</p>
              <div className="mt-8 space-y-3">
                <div className="flex items-center justify-end gap-3 text-white">
                  <i className="ri-check-line text-2xl text-[#FF6B4A]"></i>
                  <span className="text-lg">Instant digital download</span>
                </div>
                <div className="flex items-center justify-end gap-3 text-white">
                  <i className="ri-check-line text-2xl text-[#FF6B4A]"></i>
                  <span className="text-lg">All formats included (PDF, EPUB, MOBI)</span>
                </div>
                <div className="flex items-center justify-end gap-3 text-white">
                  <i className="ri-check-line text-2xl text-[#FF6B4A]"></i>
                  <span className="text-lg">Lifetime access to updates</span>
                </div>
                <div className="flex items-center justify-end gap-3 text-white">
                  <i className="ri-check-line text-2xl text-[#FF6B4A]"></i>
                  <span className="text-lg">30-day money-back guarantee</span>
                </div>
                <div className="flex items-center justify-end gap-3 text-white">
                  <i className="ri-check-line text-2xl text-[#FF6B4A]"></i>
                  <span className="text-lg">Bonus: Packet Tracer lab files included</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A4D4D] text-white py-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
            <pattern id="footer-pattern" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
              <circle cx="40" cy="40" r="1" fill="white"/>
            </pattern>
            <rect width="100%" height="100%" fill="url(#footer-pattern)"/>
          </svg>
        </div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-6">
                <img 
                  src="https://static.readdy.ai/image/019b65516b6f4faeb551f203100f56f5/009a7900ab7c5cabd69e80a4b3b0aec5.png" 
                  alt="Logo" 
                  className="h-10 w-auto brightness-0 invert"
                />
              </div>
              <form onSubmit={handleSubscribe} className="mb-6">
                <div className="flex items-center border-2 border-white/30 rounded-full overflow-hidden">
                  <input 
                    type="email" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email" 
                    className="flex-1 bg-transparent px-6 py-3 text-white placeholder-white/60 outline-none text-sm"
                    required
                  />
                  <button type="submit" className="w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-white/30 transition-colors cursor-pointer">
                    <i className="ri-mail-line text-white"></i>
                  </button>
                </div>
              </form>
              <p className="text-2xl leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
                Subscribe for exclusive content and updates
              </p>
            </div>
            
            <div>
              <h4 className="font-bold text-lg mb-4">Quick Links</h4>
              <div className="space-y-3">
                <a href="#about" className="block hover:text-[#FF6B4A] transition-colors cursor-pointer">About the Book</a>
                <a href="#ebooks" className="block hover:text-[#FF6B4A] transition-colors cursor-pointer">eBook Collection</a>
                <a href="#contents" className="block hover:text-[#FF6B4A] transition-colors cursor-pointer">Contents</a>
              </div>
            </div>
            
            <div>
              <h4 className="font-bold text-lg mb-4">Resources</h4>
              <div className="space-y-3">
                <a href="#author" className="block hover:text-[#FF6B4A] transition-colors cursor-pointer">About Author</a>
                <a href="#purchase" className="block hover:text-[#FF6B4A] transition-colors cursor-pointer">Purchase</a>
                <a href="#" className="block hover:text-[#FF6B4A] transition-colors cursor-pointer">FAQ</a>
              </div>
            </div>
            
            <div>
              <h4 className="font-bold text-lg mb-4">Support</h4>
              <div className="space-y-3">
                <a href="#" className="block hover:text-[#FF6B4A] transition-colors cursor-pointer">Contact Us</a>
                <a href="#" className="block hover:text-[#FF6B4A] transition-colors cursor-pointer">Refund Policy</a>
                <a href="#" className="block hover:text-[#FF6B4A] transition-colors cursor-pointer">Terms of Service</a>
              </div>
            </div>
          </div>
          
          <div className="pt-8 border-t border-white/20 flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-sm text-white/80">© 2024 Networking & Cybersecurity eBooks. All rights reserved.</p>
            
            <div className="flex items-center gap-6">
              <a href="#" className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:border-white transition-colors cursor-pointer">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:border-white transition-colors cursor-pointer">
                <i className="ri-facebook-line"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:border-white transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border-2 border-white/30 rounded-lg hover:border-white transition-colors cursor-pointer">
                <i className="ri-linkedin-line"></i>
              </a>
            </div>
            
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
